import axios from 'axios';

async function ObtenerPreguntaFrecuente(prmIdPreguntaFrecuente: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_preguntafrecuente"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_pregunta_frecuente": prmIdPreguntaFrecuente
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPreguntaFrecuente;